const server = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export default server;